import { Component, Input } from "@angular/core";
import { Deck, DeckCard, DeckCardTagType, DeckLayer } from "@apiserver-rest/ponder-data-client-base";
import { DeckBaseComponent } from "@ponder-features/user/decks/deck/deck-base.component";
import { MagicHandItemComponent } from "./magic-hand-item.component";
import { debounceTime, Subscription } from "rxjs";
import { DeckLayerName } from "@apiserver-rest/ponder-data-client";
import { DeckCardEvent } from "@ponder-core/events/deck.events";
import { EventBroker } from "@ponder-core/events/eventBroker";

@Component({
    selector: "magic-hand-simulator",
    imports: [MagicHandItemComponent],
    templateUrl: "magic-hand-simulator.component.html"
})
export class MagicHandSimulatorComponent {
    @Input({ required: true }) public deck!: Deck;
    @Input({ required: true }) public deckComponent!: DeckBaseComponent;

    public cardsInHand: CardInHand[] = [];
    public isBusy: boolean = false;

    private randomIndices: number[] = [];
    public mainLayer!: DeckLayer;
    private deckCardSub!: Subscription;

    public constructor(private events: EventBroker) {
        
    }

    public ngOnInit(): void {
        this.mainLayer = this.deck.layers![0];
        this.drawNewHand();

        this.deckCardSub = this.events.deck.deckCardEvent
            .pipe(debounceTime(500))
            .subscribe({
                next: (event: DeckCardEvent) => {
                    if (event.layer === DeckLayerName.Mainboard) {
                        this.drawNewHand();
                    }
                }
            });
    }

    public ngOnDestroy(): void {
        this.deckCardSub.unsubscribe();
    }

    public drawNewHand(): void {
        if (!this.mainLayer?.cards || this.isBusy) {
            return;
        }

        this.isBusy = true;
        this.cardsInHand = [];
        this.randomIndices = [];

        for (let i = 0; i < this.mainLayer.cards.length; ++i) {
            var card = this.mainLayer.cards[i];

            if (card.tag != DeckCardTagType.None) {
                // Don't have Commander, etc. in the library.
                continue;
            }

            for (let j = 0; j < (card.count + card.specialCount); ++j) {
                this.randomIndices.push(i);
            }
        }

        this.shuffle();

        for (let i = 0; (i < 7) && (i < this.randomIndices.length); ++i) {
            this.drawCard();
        }

        this.sortCards();
        this.isBusy = false;
    }

    public drawCard(): void {
        if (this.randomIndices.length) {
            var randomIndex = this.randomIndices.pop()!;            
            var deckCard = this.mainLayer!.cards![randomIndex];

            this.cardsInHand.push({ 
                deckCard: deckCard,
                id: `${deckCard.deckCardId}_${this.cardsInHand.length}`
            });
        }
    }

    public sortCards(): void {
        this.cardsInHand.sort((a, b) => {
            return a.deckCard.card.item.data!.magic!.manaValue! - b.deckCard.card.item.data!.magic!.manaValue!;
        });
    }

    // https://stackoverflow.com/a/2450976/735425
    private shuffle(): void {
        let currentIndex = this.randomIndices.length;

        // While there remain elements to shuffle...
        while (currentIndex != 0) {
      
          // Pick a remaining element...
          let randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;
      
          // And swap it with the current element.
          [this.randomIndices[currentIndex], this.randomIndices[randomIndex]] = [
            this.randomIndices[randomIndex], this.randomIndices[currentIndex]];
        }
    }
}

type CardInHand = {
    deckCard: DeckCard;
    id: string;
};
